import { Check, Landmark, PiggyBank, Wallet, CreditCard as CardIcon } from "lucide-react";
import { formatCurrency } from "@/lib/format";
import { cn } from "@/lib/cn";
import type { Account, AccountType } from "@/api/types";
import styles from "./wizardSteps.module.css";

const accountTypeIcons: Record<AccountType, typeof Wallet> = {
  checking: Landmark,
  savings: PiggyBank,
  wallet: Wallet,
  credit_card: CardIcon,
};

const accountTypeLabels: Record<AccountType, string> = {
  checking: "Conta corrente",
  savings: "Poupança",
  wallet: "Carteira física",
  credit_card: "Cartão de crédito",
};

interface AccountStepProps {
  accounts: Account[];
  accountId: string | null;
  onSelect: (id: string) => void;
}

export function AccountStep({ accounts, accountId, onSelect }: AccountStepProps) {
  return (
    <div className={styles.stepBlock}>
      <h3 className={styles.stepTitle}>De qual conta?</h3>
      <div className={styles.accountList}>
        {accounts.map((a) => {
          const Icon = accountTypeIcons[a.type];
          const selected = accountId === a.id;
          return (
            <button
              type="button"
              key={a.id}
              onClick={() => onSelect(a.id)}
              className={cn(styles.accountItem, selected && styles.accountItemSelected)}
            >
              <span className={styles.accountIcon}>
                <Icon size={18} strokeWidth={2.2} />
              </span>
              <span className={styles.accountText}>
                <span className={styles.accountName}>{a.name}</span>
                <span className={styles.accountMeta}>{accountTypeLabels[a.type]}</span>
              </span>
              <span className={styles.accountTrailing}>
                {a.type !== "credit_card" && <span className={styles.accountBalance}>{formatCurrency(a.balance)}</span>}
                {selected && (
                  <span className={styles.accountCheckBadge}>
                    <Check size={13} strokeWidth={3.5} />
                  </span>
                )}
              </span>
            </button>
          );
        })}
        {accounts.length === 0 && <p className={styles.emptyText}>Nenhuma conta cadastrada ainda.</p>}
      </div>
    </div>
  );
}
